// extracted by mini-css-extract-plugin
export default {"root":"popup_root__VWCw4","image":"popup_image__0Taaj","reload":"popup_reload__DJX0W","refresh":"popup_refresh__c4C5w"};